import { useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import MDBox from "components/MDBox";

function KpiConstraintInput({ label, value, onChange, unit = "%" }) {
  const handleEnabledChange = (event) => {
    onChange({ ...value, enabled: event.target.checked });
  };

  const handleTypeChange = (event) => {
    const newType = event.target.value;
    onChange({ ...value, type: newType });
  };

  const handleValueChange = (field) => (event) => {
    onChange({ ...value, [field]: parseFloat(event.target.value) });
  };

  return (
    <MDBox mb={2} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={value.enabled || false}
                onChange={handleEnabledChange}
                color="info"
              />
            }
            label={label}
          />
        </Grid>

        {value.enabled && (
          <>
            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                label="條件類型"
                value={value.type || "range"}
                onChange={handleTypeChange}
                size="small"
              >
                <MenuItem value="gt">大於 (&gt;)</MenuItem>
                <MenuItem value="lt">小於 (&lt;)</MenuItem>
                <MenuItem value="range">區間</MenuItem>
              </TextField>
            </Grid>

            {value.type === "range" ? (
              <>
                <Grid item xs={6} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label={`最小值 (${unit})`}
                    value={value.min || ""}
                    onChange={handleValueChange("min")}
                    size="small"
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label={`最大值 (${unit})`}
                    value={value.max || ""}
                    onChange={handleValueChange("max")}
                    size="small"
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  type="number"
                  label={`值 (${unit})`}
                  value={value.value || ""}
                  onChange={handleValueChange("value")}
                  size="small"
                />
              </Grid>
            )}
          </>
        )}
      </Grid>
    </MDBox>
  );
}

export default KpiConstraintInput;
